import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Bugme } from 'src/app/shared/models/bugme.model';

@Component({
  selector: 'hs-bugme',
  templateUrl: './bugme.component.html',
  styleUrls: ['./bugme.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BugmeComponent {

  private dataBacking: Bugme;
  @Input() set data(value: Bugme) {
    this.dataBacking = value;
    this.updateData();
  }
  get data(): Bugme {
    return this.dataBacking;
  }

  closeme = '';
  closer = '';
  animateme = '';
  fixme = '';
  zindexme = '';

  close = false;

  updateData() {
    if (!this.data) {
      return;
    }

    if (this.data.closeAlign === 'left') {
      this.closeme = ' bugme-close-left';
    }
    if (this.data.animate) {
      this.animateme = ' bugmebar-animated bugmebar-bounceInDown';
    }
    if (this.data.fixed) {
      this.fixme = ' bugme-fixed';
    }

    this.zindexme = 'z-index:' + this.data.zindex;

    const bugClosed = localStorage.getItem('bugme-' + this.data.cookieName) === 'close';
    if (!bugClosed || !this.data.remember) {
      this.data.isVisible = true;
    } else {
      this.data.isVisible = false;
    }
  }

  closeBar() {
    this.close = true;
    setTimeout(() => {
      this.data.isVisible = false;
      localStorage.setItem('bugme-' + this.data.cookieName, 'close');
    }, 750);
  }

}
